import type { EducationContent } from '/index';

export default {
  topParas: [
    <>
      This category covers emissions from your business’s <strong>consumption of electricity, heat, and steam</strong>,
      along with any <strong>energy attribute certificates (EACs)</strong> applicable to the locations included within
      the boundaries of this carbon review.
    </>,
  ],
  exampleParas: [
    <>
      Emissions in this category include, for example, those from{' '}
      <strong>electricity used at your offices or warehouses</strong> to power lighting, IT equipment, heating, and
      cooling systems during the reporting period.
    </>,
  ],
  included: {
    points: [
      {
        hasBullet: true,
        title: <strong>Locations</strong>,
        paras: [
          {
            para: (
              <>
                All <strong>sites and facilities</strong> your business occupies, either fully or partially, where you
                will enter energy consumption data as part of this carbon review. These locations may also have energy
                attribute certificates associated with them.
              </>
            ),
          },
        ],
      },
      {
        hasBullet: true,
        title: <strong>Consumption data</strong>,
        paras: [
          {
            para: (
              <>
                <strong>Electricity:</strong> Emissions from the generation and delivery of purchased electricity used
                at included locations.
              </>
            ),
            hasBullet: true,
          },
          {
            para: (
              <>
                <strong>Heat:</strong> Emissions from the generation and delivery of purchased heat used at included
                locations.
              </>
            ),
            hasBullet: true,
          },
          {
            para: (
              <>
                <strong>Steam:</strong> Emissions from the generation and delivery of purchased steam used at included
                locations.
              </>
            ),
            hasBullet: true,
          },
        ],
      },
      {
        hasBullet: true,
        title: <strong>Energy attribute certificates</strong>,
        paras: [
          {
            para: 'Any certificates or third-party agreements verifying that a specific amount of electricity (in kWh or MWh) was generated from renewable sources such as solar, wind, or hydropower.',
          },
        ],
      },
    ],
  },
  notIncluded: {
    points: [
      {
        hasBullet: true,
        title: <strong>Direct Fuel Combustion (scope 1)</strong>,
        paras: [
          {
            para: 'Emissions from fuels burned on-site (e.g., gas boilers, diesel generators) are reported under scope 1 – fuels used on-site, not here.',
          },
        ],
      },
      {
        hasBullet: true,
        title: <strong>Electricity for leased or rented buildings (scope 3)</strong>,
        paras: [
          {
            para: 'If your landlord pays for electricity at a rented or leased building, report those emissions under scope 3 – upstream leased buildings, not here.',
          },
        ],
      },
      {
        hasBullet: true,
        title: <strong>Electric vehicle charging</strong>,
        paras: [
          {
            para: 'Electricity used to charge company EVs at public stations is reported under scope 2 – EV charging on the go, not here.',
          },
        ],
      },
    ],
  },
} satisfies EducationContent;
